//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../funcionales/FormContent";
import MarcoModal from "../funcionales/MarcoModal";
import FormHeader from "../funcionales/FormHeader";
import TextButton from "../buttons/TextButton";
import Loading from "../../routes/Loading";
//------------------------------------------------------ funciones
import { submitFurgon } from "./data/Submits";
import { cargarSelects } from "../../functions/dataFunctions";
import { elementos } from "./data/FormContent";
//------------------------------------------------------ estilos
import { useCerrarConEsc } from "../../hooks/useCerrarConEsc";
import "./css/Forms.css";

const FormFurgon = ({ elemento = null, onGuardar, onClose }) => {
  useCerrarConEsc(onClose);

  const modoEdicion = !!elemento;
  const titulo = modoEdicion ? "Editar" : "Agregar";
  const subtitulo = "Furgon";
  const campos = elementos["furgones"];

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); // para los selects
  const [formData, setFormData] = useState({
    // información específica
    id: elemento?.id || "",
    chasis: elemento?.chasis || "",
    dominio: elemento?.dominio || "",
    marca: elemento?.marca || "",
    modelo: elemento?.modelo || "",
    motor: elemento?.motor || "",
    // información laboral
    interno: elemento?.interno || "",
    empresa: elemento?.empresa || "",
    persona: elemento?.persona || "",
    satelital: elemento?.satelital || "",
    estado: elemento?.estado || false,
    /* `?? null` y NO `|| false`: `false` es una respuesta cargada («no tiene»)
     * y `||` la convertiría en... `false` también, pero por el camino
     * equivocado — y sobre todo, un furgón sin el dato tiene que llegar al
     * formulario como `null` para que no quede ninguna opción marcada. Con
     * `|| false` los 679 sin cargar abrirían con «No» preseleccionado y
     * bastaría con guardar cualquier otro campo para darlos por revisados. */
    lona: elemento?.lona ?? null,
    /* Faltaba acá, y el campo es obligatorio: al editar, el formulario abría
     * con «Tipo de acoplado» vacío aunque la fila lo tuviera, y había que
     * elegirlo de nuevo en cada edición o salía «Faltan datos». */
    tipo_acoplado: elemento?.tipo_acoplado || "",
    // detalles y comentarios
    detalle: elemento?.detalle || "",
    comentarioSatelital: elemento?.comentarioSatelital || "",
    detalleSatelital: elemento?.detalleSatelital || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects(); // trae TODOS
      setListas(data);
    };

    cargarDatos();
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitFurgon(
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      modoEdicion,
      elemento?.id,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="form-content">
          <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />

          <FormContent
            elemento={elemento}
            campos={campos}
            opciones={listas}
            data={formData}
            setData={setFormData}
          />

          <div className="form-buttons">
            <TextButton
              text={"Guardar"}
              type={"button"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormFurgon;
